import { UpdateTrainingRequestData } from "@interfaces/request-training";
import requestTrainingService from "@services/request-training-service";
import { useMutation, useQueryClient } from "react-query";
import { trainingRequestsQueryKeys } from "./queryKeys";

export const useUpdateTrainingRequestMutation = (
  invalidateAfterSuccess = true
) => {
  const queryClient = useQueryClient();

  return useMutation(
    (data: UpdateTrainingRequestData) => requestTrainingService.update(data),
    {
      onSuccess: () => {
        if (invalidateAfterSuccess) {
          queryClient.invalidateQueries(trainingRequestsQueryKeys.all);
        }
      },
    }
  );
};
